

export const PAYMENT_TAB = [
    {
        key: 'all',
        label: "ทั้งหมด",
        values: 0
    },
    {
        key: 'incompleteData',
        label: "ข้อมูลไม่ครบ",
        values: 0
    },
    {
        key: 'employeeIn',
        label: "เข้าใหม่งวดนี้",
        values: 0
    },
    {
        key: 'employeeOut',
        label: "ลาออกงวดนี้",
        values: 0
    },
    {
        key: 'editedItems',
        label: "ข้อมูลที่มีการแก้ไข",
        values: 0
    },
]

export const MODAL_TAB = [
    {
        key: 'salary',
        label: "เงินเดือน"
    },
    {
        key: 'incomeDeduction',
        label: "รายได้รายหัก"
    },
    {
        key: 'overtime',
        label: "ค่าล่วงเวลา"
    },
    {
        key: 'absenceDeduct',
        label: "หักไม่มาทำงาน"
    },
    {
        key: 'lateEarlyDeduct',
        label: "หักมาสาย/กลับก่อน"
    },
    {
        key: 'accumulate',
        label: "เงินสะสมประจำปี"
    },
    {
        key: 'liabilities',
        label: "ภาระหนี๋สิน"
    },
    {
        key: 'allowance',
        label: "ลดหย่อน"
    },
    {
        key: 'tax',
        label: "ภาษี"
    },
    {
        key: 'socialSecurity',
        label: "ประกันสังคม"
    },
]

export const PAYMENT_STEP = [
    {
        title: 'Calculate',
        nameEn: 'Calculate',
        name: 'คำนวณ',
        key: 1
    },
    {
        title: 'Verify',
        nameEn: 'Verify',
        name: 'ตรวจสอบ',
        key: 2
    },
    {
        title: 'Approve',
        nameEn: 'Approve',
        name: 'อนุมัติ',
        key: 3
    },
    {
        title: 'Close the Period',
        nameEn: 'Close the Period',
        name: 'ปิดงวด',
        key: 4
    },
    {
        title: 'Pay',
        nameEn: 'Pay',
        name: 'ชำระเงิน',
        key: 5
    },
]

export const MOCK_DATA = [
    {
        "_id": "6672a46df6a2d871e157df20",
        // "companyId" : DBRef("stpCompany", ObjectId("662b4bbd153c213c2f09c189")),
        "periodNo": 1,
        "periodOfYear": 24,
        "periodPerMonth": 1,
        "month": 1,
        "year": "2024",
        "firstDateOfTheYear": "2023-12-31T17:00:00.000+0000",
        "startPeriod": "2023-12-31T17:00:00.000+0000",
        "endPeriod": "2024-01-14T17:00:00.000+0000",
        "employmentType": [
            {
                "_id": "65eadcc10a503a1602e299c3",
                "groupTypeCode": "EMPLOYMENT_TYPE",
                "code": "EMPLOYMENT_TYPE_01",
                "commonTypeName": "รายเดือน",
                "commonTypeNameEn": "Monthly",
                "statusFlag": "ACTIVE",
            },
            {
                "_id": "65eadcc10a503a1602e299c4",
                "groupTypeCode": "EMPLOYMENT_TYPE",
                "code": "EMPLOYMENT_TYPE_02",
                "commonTypeName": "รายวัน",
                "commonTypeNameEn": "Daily",
                "statusFlag": "ACTIVE",

            }
        ],
        "paymentPeriodType": "2",
        "paymentDate": "2024-01-14T17:00:00.000+0000",
        "allowPayBeforeHoliday": "N",
        "offCyclePayroll": "N",
        "offCyclePayrollStartDate": "2023-12-31T17:00:00.000+0000",
        "offCyclePayrollEndDate": "2024-01-14T17:00:00.000+0000",
        "specialPeriod": "N",
        "statusFlag": "PENDING_CALCULATION",
        // "createBy" : DBRef("stpEmployee", ObjectId("662b4bbd153c213c2f09c18a")),
        // "createDate" : ISODate("2024-06-19T09:27:09.308+0000"),
        // "_class" : "com.be.flowhr.base.common.entity.TxnPayrollPeriod"
    }
]

export const ACTION = {
    VIEW_INCOME: "view-income",
    EDIT_INCOME: "edit-income",
    VIEW_DEDUCTION: "view-deduction",
    EDIT_DEDUCTION: "edit-deduction",
    EDIT: "edit",
    VIEW: "view",
    EDIT_PAYROLL: "edit-payroll",
    PREVIEW: "preview",
}

export const PAYMENT_METHOD = [
    {
        key: "BANK",
        name: "ธนาคาร",
        nameEn: "Bank"
    },
    {
        key: "CASH",
        name: "เงินสด",
        nameEn: "Cash"
    }
]

export const STATUS_TYPE = [
    {
        title: 'Pending',
        nameEn: 'Pending',
        name: 'รอการคำนวน',
        key: '0'
    },
    {
        title: 'Calculated',
        nameEn: 'Calculated',
        name: 'คำนวนเรียบร้อยแล้ว',
        key: '1'
    },
    {
        title: 'Rejected',
        nameEn: 'Rejected',
        name: 'ไม่ผ่านการตรวจสอบ',
        key: '1.5'
    }
]

export const VERIFICATION_TYPE = [
    {
        title: 'Pending verification',
        nameEn: 'Pending verification',
        name: 'รอตรวจสอบ',
        key: '0'
    },
    {
        title: 'Verified',
        nameEn: 'Verified',
        name: 'ตรวจสอบแล้ว',
        key: '1'
    },
    {
        title: 'Rejected',
        nameEn: 'Rejected',
        name: 'ไม่ผ่านการตรวจสอบ',
        key: '1.5'
    }
]

export const PAYROLL_PERIOD_STATUS = {
    PENDING_CALCULATION: "PENDING_CALCULATION",
    PENDING_VERIFICATION: "PENDING_VERIFICATION",
    PENDING_APPROVAL: "PENDING_APPROVAL",
    PENDING_CLOSE: "PENDING_CLOSE",
    PENDING_PAYMENT: "PENDING_PAYMENT"
}

